export default "__VITE_ASSET__fpZ4ESW8__"